module.exports = __webpack_public_path__ + "static/media/Check_success.c2f1d887.gif";